import React, { useState, useEffect, useCallback} from 'react';
import './dash.css'
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import { db, auth } from '../Firebase_Config/firebase';
import { collection, query, where, orderBy, limit, getDocs, doc, getDoc, updateDoc } from 'firebase/firestore';
import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";
import Copyright from '../CopyrightFooter/Copyright';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";
import axios from 'axios';
import { handleConformityDocSubmit } from '../../services/reportGenerator';
import { Dropdown } from '../../services/dropdown';
import { AveragesTable } from '../../services/AveragesTable';


const Modal = ({ isOpen, onClose, messages, isTyping, input, handleInputChange, sendMessage }) => {
  if (!isOpen) return null;

  return (
    <div className="AicontentPop">
      <div className="AIContainerBoxPop">
        <div className="AiheaderPop">
            <h1 className="AIh1">TRAMS-AI Co-Pilot</h1>
          </div>
        <div className="chatbot-containerPop">
          <div className="chat-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {isTyping && <div className="typing-indicator">Typing...</div>}
          </div>
          <div className="inputBox">
            <form onSubmit={sendMessage}>
              <input
                className="promptInput"
                type="text"
                value={input}
                onChange={handleInputChange}
                placeholder="Ask a question..."
              />
              <button className="aibutton" type="submit">
                <svg height="24" width="24" fill="#FFFFFF" viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1" class="sparkle">
                  <path d="M10,21.236,6.755,14.745.264,11.5,6.755,8.255,10,1.764l3.245,6.491L19.736,11.5l-6.491,3.245ZM18,21l1.5,3L21,21l3-1.5L21,18l-1.5-3L18,18l-3,1.5ZM19.333,4.667,20.5,7l1.167-2.333L24,3.5,21.667,2.333,20.5,0,19.333,2.333,17,3.5Z"></path>
                </svg>
                <span className="aitext">Answer</span>
              </button>
            </form>
            <button className='closeButton' onClick={onClose}>Close</button>
          </div>
        </div>
        
      </div>
    </div>
  );
};







const Collapsible = ({ summaryText, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="collapsible">
      <div className="collapsible-header">
        <div className="arrow" onClick={() => setIsOpen(!isOpen)}>
          <MdOutlineCenterFocusWeak className='AIicon2' />
          {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          <span>{summaryText}</span>
        </div>
      </div>
      {isOpen && <div className="collapsible-content">{children}</div>}
    </div>
  );
};

const groups = [
  'Techniques and Processes',
  'Accessibility',
  'Identifiability and Linkability',
  'Security',
  'Safety',
  'Unawareness',
  'Ethics and Human Rights',
  'Non-Compliance',
];

const getUserId = () => {
  const user = auth.currentUser;
  return user ? user.uid : null; // Ensure user is logged in
};

const DashModal = ({ isOpen, onClose, selectedGroup, answers }) => {
  const [messages, setMessages] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  if (!isOpen || !selectedGroup) return null; // Return null if modal is closed or no group selected

  const groupAnswers = answers[selectedGroup]; // Get the specific group answers

  // Ensure groupAnswers is an array. If it's not, convert it.
  const groupData = Array.isArray(groupAnswers) ? groupAnswers : Object.values(groupAnswers || {});

  // Filter out the questions that do not have a recommendation
  const filteredData = groupData.filter(item => item.recommendation !== null);

  const handleOpenModal = async (content) => {
    try {
      setModalOpen(true);
      setIsTyping(true);

      // Hidden first user message (not shown in UI)
      const hiddenUserMessage = { role: 'USER', message: `Explain this in non-technical terms: ${content}` };

      const response = await axios.post(
        'https://api.cohere.ai/v1/chat',
        {
          message: hiddenUserMessage.message,
          chat_history: [],
        },
        {
          headers: {
            Authorization: `Bearer jAzSNerksrFfK85So9QvdimVTzckEmeFKGdQw3yD`,
            'Content-Type': 'application/json',
          },
        }
      );

      const botResponse = response.data.text.trim();
      const botMessage = { sender: 'bot', text: botResponse };

      // ✅ Show only the bot’s message in UI
      setMessages([botMessage]);

      // ✅ Save both hidden user message and bot reply in chat history
      setChatHistory([hiddenUserMessage, { role: 'CHATBOT', message: botResponse }]);

      setIsTyping(false);
    } catch (error) {
      console.error('Error fetching response from Cohere AI:', error);
      setMessages([{ sender: 'bot', text: 'Error generating response. Please try again.' }]);
      setIsTyping(false);
    }
  };
      
  const sendMessage = async (e) => {
    e.preventDefault();
    if (input.trim() === '') return;

    const userMessage = { sender: 'user', text: input };
    setMessages((prev) => [...prev, userMessage]);
    setIsTyping(true);
    setInput('');

    try {
      const response = await axios.post(
        'https://api.cohere.ai/v1/chat',
        {
          message: input,
          chat_history: chatHistory, // Use hidden + visible history
        },
        {
          headers: {
            Authorization: `Bearer jAzSNerksrFfK85So9QvdimVTzckEmeFKGdQw3yD`,
            'Content-Type': 'application/json',
          },
        }
      );

      const botResponse = response.data.text.trim();
      const botMessage = { sender: 'bot', text: botResponse };

      // ✅ Update UI
      setMessages((prev) => [...prev, botMessage]);

      // ✅ Update hidden history
      setChatHistory((prev) => [
        ...prev,
        { role: 'USER', message: input },
        { role: 'CHATBOT', message: botResponse },
      ]);

      setIsTyping(false);
    } catch (error) {
      console.error('Error generating response:', error);
      setMessages((prev) => [
        ...prev,
        { sender: 'bot', text: 'Error generating response. Please try again.' },
      ]);
      setIsTyping(false); 
    }
  };   

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setMessages([]);
    setChatHistory([]);
  };

  return (
    <div className="dashModal">
      <div className='dashModalContent'>
        <div className="dashModalBox">
          <h2>{selectedGroup}</h2>
          {filteredData.map((item, index) => (
            <Collapsible key={index} summaryText={item.Question}>
              <div className='AsessmentContainerBox'>
                <table className="assessment-table">
                  <thead>
                    <tr>
                      <th className="header-cell">Question</th>
                      <th className="header-cell">Recommendation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="question-text-container">
                        <div className="question-text2">{item.Question}</div>
                      </td>
                      <td className="information-box">
                        <div className="cohere-description" onClick={() => handleOpenModal(item.recommendation)} dangerouslySetInnerHTML={{ __html: item.recommendation }}></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Collapsible>
          ))}
            <Modal
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              messages={messages}
              isTyping={isTyping}
              input={input}
              handleInputChange={handleInputChange}
              sendMessage={sendMessage}
            />
          <button className='closeButton' onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};


const Dashboard = () => {
  const [answers, setAnswers] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [conformityAnswers, setConformityAnswers]= useState([])
  
  const [threatLevel, setThreatLevel] = useState('');
  const [threatLevel2, setThreatLevel2] = useState('');
  const [numOfthreats, setNumOfThreats]= useState('');
  
  const [isDashModalOpen, setisDashModalOpen] = useState(false);
  const [overallAverage, setOverallAverage] = useState(0);

  const [loading, setisloading]= useState(true)
  const [loadingMessage, setLoadingMessage] = useState("Loading your dashboard...");

  // Fetch answers from Firestore
  useEffect(() => {
    const fetchAnswersForDash = async () => {
      try {
        const userId = getUserId(); // Fetch user ID
        if (!userId) {
          console.log('User not authenticated');
          return;
        }
        const answersDocRef = doc(db, 'Answers', userId);
        const answersSnapshot = await getDoc(answersDocRef);

        if (answersSnapshot.exists()) {
          const data = answersSnapshot.data();
          console.log('Answers Data:', data); // For debugging
          setAnswers(data.ThreatAnalysis); // Store all answers
          setConformityAnswers(computeGroupAverages(data.ConformityAnalysis))
          calculateThreatLevel(data.ThreatAnalysis);
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching document:', error);
      }
    };

    fetchAnswersForDash();
    setisloading(false)
  }, []);
  
  const calculateThreatLevel = (answersData) => {
    let totalThreats = 0;

    // Iterate through each group and count the number of recommendations
    groups.forEach((group) => {
      const groupAnswers = answersData[group] || {};
      const threatCount = Object.values(groupAnswers).filter(item => item.recommendation !== null).length;
      totalThreats += threatCount;
    });

    // Assign threat level based on the total number of threats
    let level = '';
    if (totalThreats < 20) {
      level = 'Low';
    } else if (totalThreats >= 20 && totalThreats <= 60) {
      level = 'Medium';
    } else {
      level = 'High';
    }
    setNumOfThreats(totalThreats)
    setThreatLevel(level); // Update the threat level state
  };

  const getProgressBarWidth = () => {
    const maxThreats = 86; // You can adjust this value
    return Math.min((numOfthreats / maxThreats) * 100, 100); // Return number only
  };

  // ✅ Run this when overallAverage updates
  useEffect(() => {
    if (overallAverage !== null && overallAverage !== undefined) {
      if (overallAverage < 50) {
        setThreatLevel2("Low");
      } else if (overallAverage >= 50 && overallAverage <= 75) {
        setThreatLevel2("Medium");
      } else {
        setThreatLevel2("High");
      }
    }
  }, [overallAverage]);

  const computeGroupAverages = (conformityAnalysis) => {
    const groupAverages = {};

    // Helper to normalize possible Map structures
    const toObject = (maybeMap) =>
      maybeMap instanceof Map ? Object.fromEntries(maybeMap) : maybeMap;

    const data = toObject(conformityAnalysis);

    Object.entries(data).forEach(([categoryName, categoryData]) => {
      const categoryObj = toObject(categoryData);

      Object.entries(categoryObj).forEach(([goalName, goalData]) => {
        // Skip meta keys like "GroupAverage"
        if (goalName === "GroupAverage" || goalName === "GoalAverage") return;

        const goalObj = toObject(goalData);

        // If there's a stored GoalAverage, use it
        if (
          typeof goalObj.GoalAverage === "number" &&
          !isNaN(goalObj.GoalAverage)
        ) {
          groupAverages[goalName] = goalObj.GoalAverage;
        } else {
          // Otherwise compute manually from sub-entries
          const percentages = Object.values(goalObj)
            .map(toObject)
            .filter((entry) => typeof entry?.percentage === "number")
            .map((entry) => entry.percentage);

          const avg =
            percentages.length > 0
              ? percentages.reduce((a, b) => a + b, 0) / percentages.length
              : 0;

          groupAverages[goalName] = avg;
        }
      });
    });
    console.log(groupAverages)
    return groupAverages;
  };
  

  // Handle modal opening
  const openModal = (group) => {
    console.log(`Opening modal for: ${group}`); // Debugging
    setSelectedGroup(group);
    setisDashModalOpen(true);
  };

  const closeModal = () => {
    setisDashModalOpen(false);
    setSelectedGroup(null);
  };

  const ConformityReport = async (answersObj) => {
    setisloading(true);
    setLoadingMessage("Generating Your Conformity Analysis Report...");
    await handleConformityDocSubmit(answersObj)
    setisloading(false);
  };



  return (
    <div style={{backgroundColor: 'rgb(240, 242, 245)', minheight: '100vh'}}>
      {loading ? (
        // Loading screen
        <div className="loading-screen">
          <div className="Dashspinner" />
          <h2>{loadingMessage}</h2>
        </div>
        ) : (
          <div className='dashcontent'>
            <div className='dashheader'>
              <h1>Conformity Levels with AI Guidelines</h1>
            </div>        
            <h2>Current Conformity Level- {threatLevel2} </h2>
            <div className="Confomprogress-bar-container">
              <div className="ThreatBar-mask" style={{ width: `${100 - overallAverage}%` }} />
            </div>
            <AveragesTable
              setOverallAverage={setOverallAverage}
              overallAverage={overallAverage}
            />
            <Dropdown title="Conformity Analysis Report">
              <button
                className="DocumentButton bigger"
                onClick={() => ConformityReport(conformityAnswers)}
                disabled={loading} // optional: disable while generating
              >
                {loading ? 'Generating...' : 'Generate Report'}
              </button> 
            </Dropdown>
            <div>
              <h2>Threat Modeling Recommendations</h2>
              <h2>Current Threat Level- {threatLevel}</h2>
            </div>
            <div className="Threatprogress-bar-container">
              <div
                className="ThreatBar-mask"
                style={{ width: `${100 - getProgressBarWidth()}%` }}
              />
            </div>

            <div className="dashboard-containers">
              <div className="stats-box" onClick={() => openModal('Techniques and Processes')}>
                <div className="icon-box black">
                  <PiStrategyBold />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Techniques and Processes'] || {}).filter(item => item.recommendation !== null).length}  `}</h4>
                  <h3>Techniques and Processes</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>
            
              <div className="stats-box" onClick={() => openModal('Accessibility')}>
                <div className="icon-box blue">
                  <FaUniversalAccess />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Accessibility'] || {}).filter(item => item.recommendation !== null).length}  `}</h4>
                  <h3>Accessibility</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>

              {/* Identifiability and Linkability */}
              <div className="stats-box" onClick={() => openModal('Identifiability and Linkability')}>
                <div className="icon-box green">
                  <PiIdentificationCardFill />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Identifiability and Linkability'] || {}).filter(item => item.recommendation !== null).length}  `}</h4>
                  <h3>Identifiability and Linkability</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>
          
              {/* Security */}
              <div className="stats-box" onClick={() => openModal('Security')}>
                <div className="icon-box red">
                  <AiFillSecurityScan />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Security'] || {}).filter(item => item.recommendation !== null).length} `}</h4>
                  <h3>Security</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>
            </div>
            <div className="dashboard-containers level2">
              {/* Safety */}
              <div className="stats-box" onClick={() => openModal('Safety')}>
                <div className="icon-box black">
                  <AiFillSafetyCertificate />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Safety'] || {}).filter(item => item.recommendation !== null).length} `}</h4>
                  <h3>Safety</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>

              {/* Unawareness */}
              <div className="stats-box" onClick={() => openModal('Unawareness')}>
                <div className="icon-box blue">
                  <ImConfused2 />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Unawareness'] || {}).filter(item => item.recommendation !== null).length}  `}</h4>
                  <h3>Unawareness</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>

              {/* Ethics and Human Rights */}
              <div className="stats-box" onClick={() => openModal('Ethics and Human Rights')}>
                <div className="icon-box green">
                  <HiMiniUserGroup />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Ethics and Human Rights'] || {}).filter(item => item.recommendation !== null).length}  `}</h4>
                  <h3>Ethics and Human Rights</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>

              {/* Non-Compliance */}
              <div className="stats-box" onClick={() => openModal('Non-Compliance')}>
                <div className="icon-box red">
                  <GrCompliance />
                </div>
                <div className="content-box">
                  <br></br>
                  <br></br>
                  <h4>{`Number of Threats: ${Object.values(answers['Non-Compliance'] || {}).filter(item => item.recommendation !== null).length}  `}</h4>
                  <h3>Non-Compliance</h3>
                  <hr className="hrLine" />
                  <p className="change-text">Just Updated</p>
                </div>
              </div>
            </div>
            {/* Modal for displaying the questions with recommendations */}
            <DashModal isOpen={isDashModalOpen} onClose={closeModal} selectedGroup={selectedGroup} answers={answers}/>
          </div>
        )}
    </div>
  );
};

    

export default Dashboard;